import { __awaiter } from "tslib";
import axios from 'axios';
import Qs from 'qs';
import { getConfig } from '~/web-frontend-core/config';
export default class ClientAxios {
    constructor(baseUrl = getConfig('API_URL')) {
        this.handleErrors = (err) => {
            if (axios.isCancel(err)) {
                console.log('Request canceled', err.message);
                throw 'CANCELLED';
            }
            if (!getConfig('IS_SERVER') && window.setErrorRequest)
                window.setErrorRequest(err.request.status);
            return err.request.status;
        };
        this.responseBody = (res) => {
            if (res && typeof res !== 'number' && res.data) {
                return res.data;
            }
            return false;
        };
        this.post = (url, body) => __awaiter(this, void 0, void 0, function* () {
            const _o = {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            };
            return yield this.client
                .post(url, Qs.stringify(body), _o)
                .catch(this.handleErrors)
                .then(this.responseBody);
        });
        this.client = axios.create({
            baseURL: baseUrl,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/clientAxios.js